import { Component, Input, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';

@Component({
    selector: 'app-edit-activity',
    templateUrl: './edit-activity.component.html',
    styleUrls: ['./edit-activity.component.scss'],
    standalone: false
})
export class EditActivityComponent implements OnInit {

    @Input() data: any;

    // Form model
    form: any = {
        monto: 0,
        extra: 0,
        descuento: 0,
        subcontrato: false,
        comentario: '',
        turno: 'D',
        fecha: ''
    };

    displayCostoDia: number = 35;
    displayCostoNoche: number = 40;

    constructor(
        private modalCtrl: ModalController,
        private alertCtrl: AlertController
    ) { }

    ngOnInit() {
        if (this.data) {
            // Priority: worker specific cost -> default 35/40
            this.displayCostoDia = this.data.costo_dia > 0 ? this.data.costo_dia : 35;
            this.displayCostoNoche = this.data.costo_noche > 0 ? this.data.costo_noche : 40;

            const rawExtra = Number(this.data.extra || 0);
            const rawDescuento = Number(this.data.descuento || 0);

            this.form = {
                monto: (this.data.monto !== undefined && this.data.monto !== null) ? this.data.monto : (this.data.turno === 'N' ? this.displayCostoNoche : this.displayCostoDia),
                extra: rawExtra !== 0 ? rawExtra : null,
                descuento: rawDescuento !== 0 ? rawDescuento : null,
                subcontrato: this.data.subcontrato || false,
                comentario: this.data.comentario || '',
                turno: this.data.turno || 'D',
                fecha: this.data.fecha
            };
        }
    }

    updateShift(newShift: string) {
        this.form.turno = newShift;
        // Auto-update base amount when shift changes based on worker's role cost
        this.form.monto = newShift === 'D' ? this.displayCostoDia : this.displayCostoNoche;
    }

    close() {
        this.modalCtrl.dismiss();
    }

    save() {
        const payload = {
            ...this.form,
            extra: (this.form.extra !== null && this.form.extra !== undefined && this.form.extra !== '') ? Number(this.form.extra) : 0,
            descuento: (this.form.descuento !== null && this.form.descuento !== undefined && this.form.descuento !== '') ? Number(this.form.descuento) : 0
        };
        this.modalCtrl.dismiss(payload);
    }

    async delete() {
        const alert = await this.alertCtrl.create({
            header: 'Confirmar Eliminación',
            message: '¿Estás seguro de que deseas eliminar este registro?',
            cssClass: 'custom-alert',
            buttons: [
                {
                    text: 'Cancelar',
                    role: 'cancel'
                },
                {
                    text: 'Eliminar',
                    role: 'destructive',
                    cssClass: 'danger-btn',
                    handler: () => {
                        this.modalCtrl.dismiss({ delete: true });
                    }
                }
            ]
        });
        await alert.present();
    }

}
